import "./App.css";
import "./App.css";
import MainPage from "./pages/MainPage";
import { MyContextProvider } from "./store/MyContext";

function App() {
  return (
    <MyContextProvider>
      <MainPage />
    </MyContextProvider>
  );
}

export default App;
